// The editor's URLs. This file is imported by the app shell (three-pane layout, compose form), so it must stay
// tiny and must not import anything from the editor itself (TipTap lives in the lazy chunk, see ./index.tsx).

const WRITE_PATH = /^\/write(?:\/(\d+))?\/?$/;

export const isWritePath = (pathname: string) => WRITE_PATH.test(pathname);

export const writePath = (articleId?: string | null) =>
  articleId ? `/write/${articleId}` : '/write';

/**
 * Three-pane layout: while writing, the feed column becomes the editor and takes the room of the feed and the
 * post column (the global threepane.scss sizes the feed column; an inline style keeps this patch out of it).
 */
export const WRITING_FEED_STYLE: React.CSSProperties = {
  flex: '1 1 auto',
  width: 'auto',
  maxWidth: 'none',
};
